import { styled } from "styled-components";

export const InsetTextBlock = styled.div`
    margin: 15px;
`